import { getFormattedPeriod } from 'packages/common/utils/format';
import { returnFileFromResponse, throwBlobError } from 'packages/common/utils/file';
import resource from '../resource';

export function generateUnemploymentInsurance(selectedDate) {
  const unemploymentInsurance = { periodo: getFormattedPeriod(selectedDate) };
  return resource.generateUnemploymentInsurance(unemploymentInsurance)
    .then(returnFileFromResponse)
    .catch(throwBlobError);
}
